module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "landing-page"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('v-parallax', {
    staticClass: "no-parallax",
    attrs: {
      "src": _vm.site_settings.styles.landing.background_image,
      "height": _vm.parallaxHeight
    }
  }, [_c('v-layout', {
    staticClass: "header-block",
    attrs: {
      "id": "header-block",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "landing-header",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "logo-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.site_settings.styles.general.logo
    }
  })]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn--flat btn--raised theme--dark auth-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn--flat btn--raised theme--dark auth-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signin')
      }
    }
  }, [_vm._v("Sign In")])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "parallax-card"
  }, [_c('v-flex', {
    staticClass: "card-item",
    attrs: {
      "dark": ""
    }
  }, [_c('div', [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px"
    }
  }, [_vm._v("THE ONE-STOP SHOP FOR "), _c('br'), _vm._v("YOUR NEXT DEFENSE CONTRACT")])]), _vm._v(" "), _c('div', [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("SEARCH NEW OPPORTUNITIES, RESEARCH "), _c('br'), _vm._v("EXISTING CONTRACTS AND CONNECT NEW "), _c('br'), _vm._v("BUSINESS PARTNERS THROUGH THE "), _c('br'), _vm._v("GEORGIA DEFENSE EXCHANGE")])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "parallax-buttons"
  }, [_c('v-flex', {
    staticClass: "get-started-button",
    attrs: {
      "md6": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    staticClass: "signup-button",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("GET STARTED")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "returning-users-button",
    attrs: {
      "md6": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signin')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("RETURNING USERS")])])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "gdx-area",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "gdx-area-text",
    attrs: {
      "md9": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "gdx-area-text-div"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5rem",
      "margin-bottom": "10px"
    }
  }, [_vm._v("INTRODUCING THE ONE-STOP SHOP FOR YOUR NEXT DEFENSE CONTRACT")]), _vm._v(" "), _c('p', {
    staticClass: "gdx-paragraph",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Our directory of Georgia defense contractors provides detailed company profile and contract history. First time user would need to create an account, while returning users just need to sign in.\n            Your Company does not need to be a defense contractor yet to search active contract opportunities.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signup-button",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("SIGN UP")])])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "gdx-mid-logo",
    attrs: {
      "md3": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/gdx-logo-white.png"
    }
  })])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "info-text"
  }, [_c('v-flex', [_c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "#303131"
    }
  }, [_vm._v("GET STARTED ON THE GEORGIA DEFENSE EXCHANGE")])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "small": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-plus")]), _vm._v(" "), _c('h2', [_vm._v("ADD "), _c('br'), _vm._v("YOUR COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("If you do not see your company in the lookup while creating your account, create a company listing to join the exchange.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("SUBMIT COMPANY")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-comments")]), _vm._v(" "), _c('h2', [_vm._v("CONNECT "), _c('br'), _vm._v("AND COLLABORATE")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Connect with other contractors in Georgia. Once your account is approved, you will be able to communicate online.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("LEARN MORE")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-share-alt")]), _vm._v(" "), _c('h2', [_vm._v("SHARE "), _c('br'), _vm._v("YOUR FEEDBACK")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Once you've tried the Georgia exchange, share your ideas for updates. We are always looking for ways to serve the defense industry.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/')
      }
    }
  }, [_vm._v("PROVIDE INPUT")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-question")]), _vm._v(" "), _c('h2', [_vm._v("FREQUENTLY "), _c('br'), _vm._v("ASKED QUESTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Find out more about the special features included in this platform and how you can use them to grow your business.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": "",
      "href": "/static/GDX-user-guid-v2.pdf",
      "target": "_blank"
    }
  }, [_vm._v("FAQ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider footer-divider-first",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider footer-divider-second",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-expansion-panel', [_c('v-container', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h5', {
    staticClass: "privacy-header"
  }, [_vm._v("Legal, Privacy & Copyright Information")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n              The Georgia Defense Exchange is compiled from third party sources and is provided “as is” without warranty of any kind. The Georgia Defense Exchange is provided for informational purposes only and the Georgia Department of Economic Development in no way guarantees the accuracy or veracity of the information contained herein nor does the Georgia Department of Economic Development accept any liability for the accuracy, content, completeness, legality, or reliability of the information contained on this website.\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8096ad9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/IndexView.vue
// module id = 1707
// module chunks = 27